import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Paper, Typography } from '@material-ui/core'
import { Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import './Login.css'
import { useSelector } from 'react-redux'
import useRouter from 'utils/useRouter'
import { useDispatch } from 'react-redux'
import { login } from 'redux/actions'
import { validateEmail } from 'utils/validateEmail'
import validatePassword from 'utils/validatePassword'
import appApiUrl from 'utils/apiUrl'
import { useSnackbar } from 'notistack'
import Copyright from 'components/Copyright/Copyright'

const useStyles = makeStyles(() => ({
  root: {
    margin: '0 2em'
  },
  button: {
    marginBottom: '2em',
    width: '100%'
  },
  signup: {
    color: 'black',
    textAlign: 'center',
    margin: '1.5em 0',
    fontSize: '0.875rem',
    fontWeight: 600
  },
  title: {
    padding: '25px 0'
  },
  error: {
    color: 'red'
  }
}))

export default function Login() {
  const { enqueueSnackbar } = useSnackbar()
  const classes = useStyles()
  const dispatch = useDispatch()
  const [Error, setError] = useState('')
  const [User, setUser] = useState({
    email: '',
    password: ''
  })
  const loggedIn = useSelector(state => state.session.loggedIn)
  const userType = useSelector(state => state.session.userType)
  const router = useRouter()

  useEffect(() => {
    if (loggedIn) {
      router.history.push(
        userType?.includes('admin') ? '/pending-campaigns' : '/dashboard'
      )
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router, loggedIn, userType])
  const handleLogin = () => {
    var myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')

    var raw = JSON.stringify({
      email: User.email,
      password: User.password
    })

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    }

    fetch(`${appApiUrl}users/login.php`, requestOptions)
      .then(response => response.json())
      .then(response => {
        response.state || response.is_success
          ? dispatch(login(response))
          : setError('Login failed! please check your email and/or password')
      })
      .catch(function(error) {
        setError('Login failed! unknown error occurred')
        enqueueSnackbar(error.message, {
          variant: 'error'
        })
      })
  }
  const isValidEmail = !User.email || validateEmail(User.email)
  const isValidPassword = !User.password || validatePassword(User.password)

  const disableLoginBtn =
    !User.email || !User.password || !isValidEmail || !isValidPassword

  const onEnterLogin = e => {
    if (e.key === 'Enter' && !disableLoginBtn) handleLogin()
  }
  return (
    <div className="loginpaper">
      <Paper elevation={7}>
        <div className={classes.root}>
          <Typography variant="h2" align="center" className={classes.title}>
            Account Log-in
          </Typography>
          {Error && (
            <Typography
              variant="body1"
              align="center"
              className={classes.error}>
              {Error}
            </Typography>
          )}
          <label>Email</label>
          <input
            onChange={e => setUser({ ...User, email: e.target.value })}
            placeholder="name@domain.com"
            className={isValidEmail ? '' : 'input-error'}
            type="text"
            onKeyDown={onEnterLogin}
          />
          <label>Password</label>
          <input
            maxLength={32}
            onChange={e => setUser({ ...User, password: e.target.value })}
            type="password"
            className={isValidPassword ? '' : 'input-error'}
            placeholder="************"
            onKeyDown={onEnterLogin}
          />

          <Button
            className={classes.button}
            variant="contained"
            color="primary"
            disableElevation
            onKeyDown={onEnterLogin}
            onClick={handleLogin}
            disabled={disableLoginBtn}
            startIcon={<ExitToAppIcon />}>
            Log in
          </Button>
        </div>
      </Paper>
      <p className={classes.signup}>
        Not a member?{' '}
        <Link to="/signup" style={{ color: 'red' }}>
          Sign Up
        </Link>{' '}
        here
      </p>

      <Copyright />
    </div>
  )
}
